const SystemManagementEvent = {
  SYSTEM_STATUS_UPDATED: 'SYSTEM_STATUS_UPDATED',
};

export default SystemManagementEvent;
